var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { updateVisit } from '../services/CalendarService';
export function useUpdateVisit() {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (_a) => __awaiter(this, [_a], void 0, function* ({ visitId, data }) {
            const response = yield updateVisit(visitId, data);
            if (response.error) {
                throw new Error(response.error.message);
            }
            return response.data;
        }),
        onMutate: (_a) => __awaiter(this, [_a], void 0, function* ({ visitId, data }) {
            yield queryClient.cancelQueries({ queryKey: ['calendar', 'visits'] });
            const previousVisitsQueries = queryClient.getQueriesData({
                queryKey: ['calendar', 'visits']
            });
            queryClient.setQueriesData({ queryKey: ['calendar', 'visits'] }, (old) => {
                if (!old)
                    return old;
                return Object.assign(Object.assign({}, old), { visits: old.visits.map((v) => (v.id === visitId ? Object.assign(Object.assign({}, v), { start: data.start, end: data.end }) : v)) });
            });
            return { previousVisitsQueries };
        }),
        onError: (_err, _vars, context) => {
            var _a;
            (_a = context === null || context === void 0 ? void 0 : context.previousVisitsQueries) === null || _a === void 0 ? void 0 : _a.forEach(([queryKey, oldData]) => {
                queryClient.setQueryData(queryKey, oldData);
            });
            toast.error('Failed to update visit. Change has been reverted.');
        },
        onSettled: () => {
            void queryClient.invalidateQueries({ queryKey: ['calendar', 'visits'] });
        }
    });
}
